(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.kafMobileMenu = {
    attach: function (context, settings) {
      const $menuBlock = $('#block-kafsubmenu', context);
      if (!$menuBlock.length) {
        return;
      }

      const wrapperSelector = '.mnav-wrapper';
      const activeClass = 'is-slid';
      const keydownTargets = $('.menu__trigger, #mobile-nav, .mnav-wrapper', context);
      const $menuTriggerButton = $('.menu__trigger', context);
      const $body = $('body', context);

      // Wrap focus within each menu panel, skipping submenus.
      function trapFocus(element) {
        var deeperPanelContent = element.find('.mnav-wrapper a, .mnav-wrapper button');
        var focusable = $menuTriggerButton.add(element.find('a, button').not(deeperPanelContent));

        // Since menu__trigger is in all loops, namespace so handler can be unset.
        $menuTriggerButton.add(element).on('keydown.kafMobileMenu', function(e) {
          if (e.keyCode != 9) {
            return;
          }
          var currentElement = document.activeElement;
          var currentIndex = focusable.index(currentElement);
          // Tabbing backwards if shift, forward otherwise.
          if ( e.shiftKey ) {
            if (currentIndex === 0) {
              focusable[focusable.length - 1].focus();
              e.preventDefault();
            }
            if (currentIndex > 0) {
              focusable[currentIndex - 1].focus();
              e.preventDefault();
            }
          } else {
            if (currentIndex === (focusable.length - 1)) {
              focusable[0].focus();
              e.preventDefault();
            }
            else if (currentIndex >= 0) {
              focusable[currentIndex + 1].focus();
              e.preventDefault();
            }
          }
        });
      }

      function adjustArticlesWrapperPosition(nextWrapper, actionType) {
        var ulHeight;
        var newTopPosition;
        var parentLi = nextWrapper.find('ul').closest('li.mnav-l1--item');
        var articleWrapper = parentLi.find('#articles-wrapper');

        if (actionType === 'more') {
          ulHeight = nextWrapper.find('ul[class^="mnav"]').first().height();
            newTopPosition = ulHeight + 116;
        } else if (actionType === 'back') {
          var parentUl = nextWrapper.closest('ul[class^="mnav"]');
          if (parentUl.length) {
              ulHeight = parentUl.height();
              newTopPosition = ulHeight + 116;
          } else {
              console.error("Parent <ul> not found.");
              return;
          }
        }
        articleWrapper.css('top', newTopPosition + 'px');
      }

      $('.mnav-more', $menuBlock).click(function(e) {
        var nextWrapper = $(this).next(wrapperSelector);
        nextWrapper.addClass('is-sliding');
        setTimeout(() => {
          nextWrapper.removeClass('is-sliding').addClass('is-slid');

          nextWrapper.addClass(activeClass).attr('aria-hidden', 'false');
          $(keydownTargets).off('keydown.kafMobileMenu');
          trapFocus(nextWrapper);

          adjustArticlesWrapperPosition(nextWrapper, 'more');

          // All setTimeouts are to make focus operate in Safari.
          window.setTimeout(function() {
            nextWrapper.find('button, a').first().focus();
          }, 1);

          if ($(this).closest('.is-slid').length > 0) {
            $(this).closest('.is-slid').addClass('slid-parent');
          }
        }, 300);
        e.preventDefault();
      });

      $('.mnav-back', $menuBlock).click(function(e) {
        var currentWrapper = $(this).closest(wrapperSelector);
        currentWrapper.removeClass(activeClass).attr('aria-hidden', 'true');

        var nextWrapper = $(this).parents('ul').first();

        nextWrapper.addClass('is-sliding');

        setTimeout(() => {
          // Ensure we're working with the correct nextWrapper
        var nextWrapper = $(this).closest('ul');

        // Remove classes and add new one
        nextWrapper.removeClass('is-sliding').addClass('is-slid');

          var slidParent = $(this).closest('.slid-parent');
          $(keydownTargets).off('keydown.kafMobileMenu');

          var nextWrapper = $(this).closest('ul');
          adjustArticlesWrapperPosition(nextWrapper, 'back');

          if (slidParent.length > 0) {
            trapFocus(slidParent);
            window.setTimeout(function() {
              slidParent.find('button, a').first().focus();
              slidParent.removeClass('slid-parent');
            }, 1);
          } else {
            trapFocus($('#mobile-nav'));
            window.setTimeout(function() {
              $('#mobile-nav').find('button, a').first().focus();
            }, 1);
          }
        }, 300);
        e.preventDefault();
      });

      // Close panels with escape.
      $(wrapperSelector, $menuBlock).on('keydown', function(e) {
        if (e.keyCode === 27) {
          $(this).find('.mnav-back').first().click();
          e.stopPropagation();
        }
      });

      $(once('mobile-menu-trigger-click', $menuTriggerButton)).click(function() {

        if ($menuBlock.hasClass('is-expanded')) {
          // Close menu, remove classes.
          $menuTriggerButton.removeClass('is-open');
          $body.removeClass('mobile-nav-is-open');

          // Destroy click handler for when the menu is open.
          $body.off('click.menuOpen');

          // Animate closing.
          $menuBlock.animate({left: '100%'}, 300, function() {
            $menuBlock.removeClass('is-expanded');
            $menuBlock.attr('style', '');
            $(wrapperSelector).removeClass('is-slid slid-parent');
          });
        } else {
          // Open menu, add classes.
          $menuTriggerButton.addClass('is-open');
          $body.addClass('mobile-nav-is-open');
          $menuBlock.addClass('is-expanded');

          // Add click handler for the open menu.
          $body.on('click.menuOpen', function(e) {
            if (($(e.target).closest($menuTriggerButton).length === 0) && ($(e.target).closest('#block-kafsubmenu').length === 0)) {
              e.preventDefault();
              $menuTriggerButton.trigger('click');
            }
          });
        }

        if ($menuTriggerButton.attr('aria-expanded') === 'true') {
          $menuTriggerButton.attr('aria-expanded', 'false');
          $(keydownTargets).off('keydown.kafMobileMenu');
          window.setTimeout(function() {
            $menuTriggerButton.focus();
          }, 1);
        }
        else {
          $menuTriggerButton.attr('aria-expanded', 'true');
          trapFocus($('#mobile-nav'));
          window.setTimeout(function() {
            $('#mobile-nav').find('button, a').first().focus();
          }, 1);
        }
      });

      // Close whole thing with escape.
      $('.block-kaf-submenu:not(' + wrapperSelector + ')', context).on('keydown', function(e) {
        if (e.keyCode === 27) {
          $menuTriggerButton.click();
        }
      });

    },
  };
})(jQuery, Drupal);
